/**
 * AI 实验室
 * @returns
 */
import {
  Box,
  Flex,
  SimpleGrid,
  Text,
  Image,
  useBreakpointValue,
  useToast,
} from "@chakra-ui/react";
import labBg from "@/assets/images/laboratory_bg.png";
import labImg1 from "@/assets/images/labimg1.png";
import labImg2 from "@/assets/images/labimg2.png";
import labImg3 from "@/assets/images/labimg3.png";
import labImg4 from "@/assets/images/labimg4.png";
import labImg5 from "@/assets/images/labimg5.png";
import labImg6 from "@/assets/images/labimg6.png";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";

const Laboratory = () => {
  const columns = useBreakpointValue({
    base: 1,
    sm: 1,
    md: 1,
    lg: 2,
    xl: 3,
  });

  const user = useSelector(selectUser);
  const toast = useToast();

  // 打开毛坯房精装页面
  const handleOpenSMRoom = () => {
    // 在新窗口中打开
    window.open("/ai/smroom", "_blank");
    // if (user && user.id) {
      
    // } else {
    //   toast({
    //     title: "请登录系统",
    //     position: "top",
    //     status: "error",
    //     duration: 1000,
    //   });
    // }
  };

  // 打开我的模型页面
  const handleOpenModel = () => {
    window.open("/creatorcenter/mymodels", "_blank");
  }

  return (
    <Box
      minH="calc(100vh - 61px)"
      overflow="hidden"
      position={"relative"}
      bg={`url('${labBg}')`}
      backgroundSize="cover"
      backgroundPosition="center center"
      bgRepeat={"no-repeat"}
    >
      <Box width="80%" m="0 auto">
        <Box
          mt="111px"
          fontSize={"48px"}
          fontWeight="900"
          sx={{
            background:
              "-webkit-linear-gradient(90deg, rgba(0, 0, 0, 0.85) 0%, rgba(58, 58, 58, 0.58) 76%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          ALDGPT 设计实验室
        </Box>
        <Box fontSize={"34px"} color="#616161" mt="16px">
          探索更多好用功能
        </Box>
        <SimpleGrid mt="80px" mb="100px" columns={columns} spacing={"18px"}>
          <Flex bgColor={"#fff"} p="20px" gap="20px">
            <Image boxSize="157px" src={labImg1} />
            <Flex flexDir={"column"} color={"#27314D"} opacity="0.5">
              <Box fontSize={"18px"} fontWeight="bold" mb="10px">
                开源+本地部署
              </Box>
              <Box flex={1} fontSize={"14px"}>
                <Box
                  style={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 4, // 限制为两行
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  支持使用个人本地消费级显卡或 COTAB 算力的私有化部署
                </Box>
              </Box>
              <Box fontSize={"12px"} mt="10px">
                敬请期待
              </Box>
            </Flex>
          </Flex>

          <Flex bgColor={"#fff"} p="20px" gap="20px" cursor={"pointer"} onClick={handleOpenModel}>
            <Image boxSize="157px" src={labImg2} />
            <Flex flexDir={"column"} color={"#27314D"} opacity="0.5">
              <Box fontSize={"18px"} fontWeight="bold" mb="10px">
                专属模型
              </Box>
              <Box flex={1} fontSize={"14px"}>
                <Box
                  style={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 4, // 限制为两行
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  上传训练图片集，选择基础模型，调节参数，开始训练您的专属模型。
                </Box>
              </Box>
              <Box fontSize={"12px"} mt="10px">
                功能开放中
              </Box>
            </Flex>
          </Flex>

          <Flex bgColor={"#fff"} p="20px" gap="20px">
            <Image boxSize="157px" src={labImg3} />
            <Flex flexDir={"column"} color={"#27314D"} opacity="0.5">
              <Box fontSize={"18px"} fontWeight="bold" mb="10px">
                图片动图生成
              </Box>
              <Box flex={1} fontSize={"14px"}>
                <Box
                  style={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 4, // 限制为两行
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  图片旋转起来体验LIVE动图的效果，输入一张主体清晰明确的图片，体验让你的图片动起来的效果
                </Box>
              </Box>
              <Box fontSize={"12px"} mt="10px">
                敬请期待
              </Box>
            </Flex>
          </Flex>

          <Flex bgColor={"#fff"} p="20px" gap="20px">
            <Image boxSize="157px" src={labImg4} />
            <Flex flexDir={"column"} color={"#27314D"} opacity="0.5">
              <Box fontSize={"18px"} fontWeight="bold" mb="10px">
                多视角效果图
              </Box>
              <Box flex={1} fontSize={"14px"}>
                <Box
                  style={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 4, // 限制为两行
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  可以生成同一空间结构，多角度视图，更高效表达设计效果
                </Box>
              </Box>
              <Box fontSize={"12px"} mt="10px">
                敬请期待
              </Box>
            </Flex>
          </Flex>

          <Flex
            bgColor={"#fff"}
            p="20px"
            gap="20px"
            cursor={"pointer"}
            onClick={handleOpenSMRoom}
          >
            <Image boxSize="157px" src={labImg5} />
            <Flex flexDir={"column"} color={"#27314D"} opacity="0.5">
              <Box fontSize={"18px"} fontWeight="bold" mb="10px">
                毛坯房精装
              </Box>
              <Box flex={1} fontSize={"14px"}>
                <Box
                  style={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 4, // 限制为两行
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  可对毛坯房和空间进行美化处理
                </Box>
              </Box>
              <Box fontSize={"12px"} mt="10px">
                功能开放中
              </Box>
            </Flex>
          </Flex>

          <Flex bgColor={"#fff"} p="20px" gap="20px">
            <Image boxSize="157px" src={labImg6} />
            <Flex flexDir={"column"} color={"#27314D"} opacity="0.5">
              <Box fontSize={"18px"} fontWeight="bold" mb="10px">
                更多功能～
              </Box>
              <Box flex={1} fontSize={"14px"}>
                <Box
                  style={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 4, // 限制为两行
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  正在疯狂开发中，感谢您的持续关注
                </Box>
              </Box>
              <Box fontSize={"12px"} mt="10px">
                敬请期待
              </Box>
            </Flex>
          </Flex>
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default Laboratory;
